import React from 'react'
import { Filters, FilterButton } from './styled'
import { useDispatch, useSelector } from 'react-redux'
import { selectNftStat, changeFilter } from 'state/nftstat/slice'
import fetchNftStatBySlug from 'state/nftstat/actions/fetchNftBySlug'

const DailyFilter = ({ slug }: { slug: string }) => {
  const dispatch = useDispatch()
  const { filter, items } = useSelector(selectNftStat)
  const data = items[slug]

  const setFilter = (value: number) => {
    dispatch(changeFilter(value))

    if (!data.days[value]) {
      dispatch(fetchNftStatBySlug(slug))
    }
  }

  return (
    <Filters>
      <FilterButton active={filter === 7} onClick={() => setFilter(7)}>
        7D
      </FilterButton>
      <FilterButton active={filter === 14} onClick={() => setFilter(14)}>
        14D
      </FilterButton>
      <FilterButton active={filter === 30} onClick={() => setFilter(30)}>
        1M
      </FilterButton>
    </Filters>
  )
}

export default DailyFilter
